// @ts-nocheck
/**
 * drawInfoDisplay.ts
 * ドロー情報表示・クリップボード関連メソッド
 * App.vue から切り出し
 */

type VM = any

export function closeDrawInfo(vm: VM) {
  // 情報ボックスを閉じる
  vm.clickedFeatureInfo = null;
  vm.$store.state.drawInfoVisible = false;
  const infoElement = document.getElementById('draw-realtime-info');
  if (infoElement) {
    infoElement.innerHTML = '';
  }
}
export function autoOpenDrawModeIfNeeded(vm: VM) {
  // ドロー地物（config以外）がある場合は自動でドローモードを開く
  try {
    const geojsonText = vm.$store.state.clickCircleGeojsonText;
    // 空文字列、スペースのみ、undefined、nullはスキップ
    if (!geojsonText || typeof geojsonText !== 'string' || !geojsonText.trim()) return;

    const geojson = JSON.parse(geojsonText);
    if (!geojson || !geojson.features) return;

    // config以外の地物があるかチェック
    const hasDrawFeatures = geojson.features.some(f => f.properties?.id !== 'config');
    if (hasDrawFeatures) {
      vm.$store.state.suppressDrawPitchReset = true

      // マップソースにデータをセット（ドローデータを表示するが、ドローモードにはしない）
      const map01 = vm.$store.state.map01;
      if (map01 && map01.getSource('click-circle-source')) {
        map01.getSource('click-circle-source').setData(geojson);
      }

      // レイヤーのvisibilityとopacityを適用
      applyDrawLayerVisibility(vm);
      vm.$nextTick(() => {
        vm.$store.state.suppressDrawPitchReset = false
      })
    }
  } catch (e) {
    console.error('[autoOpenDrawModeIfNeeded] Error:', e);
  }
}
export function applyDrawLayerVisibility(vm: VM, targetMapName) {
  // ドローレイヤーの表示/非表示と不透明度を適用（全マップ対応）
  const mapNames = targetMapName ? [targetMapName] : ['map01', 'map02', 'map03', 'map04']
  const globalVisible = vm.$store.state.drawVisible
  const opacity = vm.$store.state.drawOpacity
  const perMap = vm.$store.state.drawVisiblePerMap

  const layerIds = [
    'click-circle-layer',
    'click-circle-polygon-line-layer',
    'click-circle-polygon-symbol-layer',
    'click-circle-polygon-symbol-area-layer',
    'click-circle-line-layer',
    'click-circle-keiko-line-layer',
    'click-circle-memo-mark-layer',
    'click-circle-label-layer',
    'click-circle-center-label-layer',
    'click-circle-symbol-layer',
    'arrows-endpoint-layer',
    'segment-label-layer'
  ]

  const opacityMap = [
    ['click-circle-layer', 'fill-opacity'],
    ['click-circle-polygon-line-layer', 'line-opacity'],
    ['click-circle-polygon-symbol-layer', 'text-opacity'],
    ['click-circle-polygon-symbol-area-layer', 'text-opacity'],
    ['click-circle-line-layer', 'line-opacity'],
    ['click-circle-keiko-line-layer', 'line-opacity'],
    ['click-circle-memo-mark-layer', 'text-opacity'],
    ['click-circle-label-layer', 'text-opacity'],
    ['click-circle-center-label-layer', 'text-opacity'],
    ['click-circle-symbol-layer', 'circle-opacity'],
    ['arrows-endpoint-layer', 'icon-opacity'],
    ['segment-label-layer', 'text-opacity'],
  ]

  for (const mapName of mapNames) {
    const map = vm.$store.state[mapName]
    if (!map) continue

    const visible = globalVisible && perMap[mapName]
    const v = visible ? 'visible' : 'none'

    // visibility適用
    layerIds.forEach(layerId => {
      if (map.getLayer(layerId)) {
        map.setLayoutProperty(layerId, 'visibility', v)
      }
    })

    // opacity適用
    if (visible) {
      opacityMap.forEach(([layerId, prop]) => {
        if (map.getLayer(layerId)) {
          map.setPaintProperty(layerId, prop, opacity)
        }
      })
    }
  }
}
export async function copyDrawInfo(vm: VM) {
  // 情報ボックスのテキストをクリップボードにコピー（iPhone対応）
  const infoElement = document.getElementById('draw-realtime-info');
  if (!infoElement) return;

  // テキストを抽出（HTMLタグを除去し、整形）
  const textContent = extractDrawInfoText(vm, infoElement);
  if (!textContent) return;

  try {
    // 最新のClipboard API（iPhone Safari 13.4以降対応）
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(textContent);
      vm.snackbarText = 'クリップボードにコピーしました';
      vm.snackbar = true;
    } else {
      // フォールバック: execCommand（古いブラウザ・iPhone対応）
      copyWithExecCommand(vm, textContent);
    }
  } catch (err) {
    console.warn('Clipboard API failed, using fallback:', err);
    // フォールバック: execCommand
    copyWithExecCommand(vm, textContent);
  }
}
export function extractDrawInfoText(vm: VM, element) {
  // 情報ボックスのHTML構造からテキストを整形して抽出
  const title = element.querySelector('.info-title')?.textContent?.trim() || '';
  const value = element.querySelector('.info-value')?.textContent?.trim() || '';
  const subtitle = element.querySelector('.info-subtitle')?.textContent?.trim() || '';

  const items = [];
  element.querySelectorAll('.info-item').forEach(item => {
    const label = item.querySelector('.info-label')?.textContent?.trim() || '';
    const number = item.querySelector('.info-number')?.textContent?.trim() || '';
    if (label && number) {
      items.push(`${label}: ${number}`);
    }
  });

  // 線の「各区間」など info-segments も拾う
  const segments = [];
  element.querySelectorAll('.info-segment-item').forEach(seg => {
    const text = seg.textContent?.trim();
    if (text) segments.push(text);
  });

  let text = title ? `【${title}】\n` : '';
  if (value) text += `${value}${subtitle ? ' ' + subtitle : ''}\n`;
  if (items.length > 0) text += items.join('\n');
  if (segments.length > 0) text += `\n${segments.join('\n')}`;

  return text;
}
export function copyWithExecCommand(vm: VM, text) {
  // iPhone Safari用のフォールバック
  const textArea = document.createElement('textarea');
  textArea.value = text;
  // iPhone対策: readonly属性を設定してキーボードが出ないようにする
  textArea.setAttribute('readonly', '');
  textArea.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
  document.body.appendChild(textArea);

  // iPhone対策: selectionRangeを使用
  const range = document.createRange();
  range.selectNodeContents(textArea);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
  textArea.setSelectionRange(0, text.length);

  try {
    document.execCommand('copy');
    vm.snackbarText = 'クリップボードにコピーしました';
    vm.snackbar = true;
  } catch (err) {
    console.error('Copy failed:', err);
    vm.snackbarText = 'コピーに失敗しました';
    vm.snackbar = true;
  }

  document.body.removeChild(textArea);
}